import axios from "axios";
import op from "../../../../modulos/datos";

class RenovacionLicenciaService {
  constructor() {
    this.token = localStorage.getItem("jwtToken");
    this.conexion = op.conexion;
  }
  getHeaders() {
    return {
      headers: {
        "x-access-token": `${this.token}`,
        "Content-Type": "application/json",
      },
    };
  }
  async getAll(filtro, anio) {
    try {
      console.log(filtro)
      let condicion = ``;
      if (filtro === "por_aprob") {
        condicion =
          "r.estatusrenovacion in (1,12) and r.usuarioaprueba = 0 and";
      } else if (filtro === "por_revi") {
        condicion = "r.estatusrenovacion = 10 and";
      } else if ((filtro === "por_proce")) {
        condicion = "r.estatusrenovacion = 11 and";
      } else if ((filtro === "aprob_impr")) {
        condicion = "r.estatusrenovacion = 2 and";
      } else if (filtro === "aprob_entre") {
        condicion =
          "r.estatusrenovacion = 3 or (r.estatusrenovacion = 1 and usuarioentrega = 0 and usuarioaprueba != 0) and";
      } else if (filtro === "entregadas") {
        condicion =
          "r.estatusrenovacion = 4 or (r.estatusrenovacion = 1 and usuarioentrega != 0) and";
      } else if (filtro === "todas") {
        condicion = "r.estatusrenovacion >= 0 and";
      }
      condicion += ` r.fechasolicitud between '${anio}-01-01' and '${anio}-12-31'`;
      const campos = ` 
      r.idrenovacion,
      r.idcontribuyente,
      r.fechasolicitud,
      r.estatusrenovacion,
      r.motivorechazo,
      r.rechazodia,
      trim(c.nombre) as nombre,
      trim(c.rif) as cedularif,  
      trim(c.direccion) as direccion,
      trim(COALESCE(p.nombres, '')) as nombre_persona,
      trim(COALESCE(p.apellidos, '')) as apellido_persona,
      CASE 
        WHEN estatusrenovacion = 0 THEN 'PENDIENTE'
        when estatusrenovacion = 1 and usuarioaprueba = 0 then 'PAGO REGISTRADO'
        when estatusrenovacion = 2 then 'IMPRESA POR FIRMA'
        when estatusrenovacion = 3 or (estatusrenovacion = 1 and estatusnotificacion = 1 and usuarioentrega = 0 and usuarioaprueba != 0) then 'POR RETIRAR'
        when estatusrenovacion = 4 or (estatusrenovacion = 1 and estatusnotificacion = 1 and usuarioentrega != 0) then 'Entregados'
        when estatusrenovacion = 10 then 'Por Revisión'
        when estatusrenovacion = 11 then 'Por Procesar'
        when estatusrenovacion = 12 then 'Revisado/Espera'
        when estatusrenovacion = 5 then 'RECHAZADA'
      END AS status
      `;
      const tabla = `
      renovacion r
      inner join comercio c on r.idcontribuyente = c.idcomercio
      LEFT JOIN usuario u ON r.usuariorechaza = u.idusuario
      LEFT JOIN persona p ON p.cedula = CAST(
          regexp_replace(CAST(u.persona AS text), '[^0-9]', '', 'g') AS bigint
      )
      `;
      const orden = `r.idrenovacion`;
      const response = await axios.get(
        `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${tabla}&condi=${condicion}&orden=${orden}`,
        this.getHeaders(),
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new RenovacionLicenciaService();
